import { c as _c } from "react/compiler-runtime";
import { useToast } from "@/hooks/use-toast";
import { useMutation } from "@tanstack/react-query";
import { createGoogleLeadConversationAction } from "../actions";
export const useCreateGoogleLeadConversationMutation = () => {
  const $ = _c(2);
  const {
    toast
  } = useToast();
  let t0;
  if ($[0] !== toast) {
    t0 = {
      mutationFn: createGoogleLeadConversationAction,
      onError: () => {
        toast({
          title: "Erro ao enviar mensagem",
          variant: "destructive"
        });
      }
    };
    $[0] = toast;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};